import { AppPage } from "@/features/app-page";
import { ToolHashType } from "@/gql/__generated__/graphql";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app-layout/shared/$sharedAppHash")({
  component: SharedAppPage
});

function SharedAppPage() {
  const { sharedAppHash } = Route.useParams();

  return <AppPage appHash={sharedAppHash} hashType={ToolHashType.Shared} />;
}
